import { Injectable, 
  // NgZone, 
  OnDestroy } from "@angular/core";
// import { Router } from "@angular/router";
// import { TranslateService } from "@ngx-translate/core";
// import { FirebaseApp } from 'firebase/app';
import {
  // AppCheck,
  AppCheckTokenResult,
  // ReCaptchaEnterpriseProvider,
  // getToken,
  // initializeAppCheck,
} from "firebase/app-check";
// import { Subscription } from "rxjs";
// import { environment } from "src/environments/environment";
// import { AppCheckStatusService } from "./services/app-check-status.service";
// import { FirebaseFactoryService } from "./services/firebase-factory.service";
// import { NotificationsService } from "./services/notifications.service";


@Injectable({
  providedIn: "root",
})
export class AppCheckService implements OnDestroy {

  async getToken(forceRefresh): Promise<AppCheckTokenResult | undefined> {
    // App Check completely disabled - always return undefined
    return forceRefresh ? undefined : undefined;
  }

  async reloadAppCheck() {
    // No-op - App Check is disabled
    return;
  }

  ngOnDestroy(): void {
    // No cleanup needed - App Check is disabled
  }
  /* ORIGINAL IMPLEMENTATION COMPLETELY COMMENTED OUT */
  // ===================================================================================================
  // private app: FirebaseApp;
  // private appCheck!: AppCheck;
  // private translationSubscription: Subscription | undefined;
  // private tokenRefreshTimeout: ReturnType<typeof setTimeout> | null = null;
  // private reCaptchaSiteKey = environment.recaptcha?.siteKey || '6LdUZAIgAAAAADZ1X7TC9RcNMEodH1jg8hiQ2ifB';
  // private tokenRefreshIntervalMs = 30 * 60 * 1000; // 30 minutes
  // private usingFallbackMode = false;
  // private maxRetries = 3;
  // private lastTokenTimestamp: number | null = null;
  // private tokenValidityDurationMs = 60 * 60 * 1000; // 1 hour estimated
  // private handleOnline!: () => void;
  // private handleOffline!: () => void;

  // constructor(
  //   private translate: TranslateService,
  //   private firebaseFactory: FirebaseFactoryService,
  //   private notificationService: NotificationsService,
  //   private ngZone: NgZone,
  //   private appCheckStatusService: AppCheckStatusService,
  //   private router: Router
  // ) {
  //   this.app = this.firebaseFactory.getFirebaseApp();

  //   // Debug token setup
  //   if (!environment.production && location.hostname === 'localhost') {
  //     self['FIREBASE_APPCHECK_DEBUG_TOKEN'] = false;
  //   }

  //   this.initializeAppCheck();
  //   this.setupNetworkListeners();
  //   this.setupTokenRefresh();

  //   this.getToken(true).catch(err =>
  //     console.warn('[AppCheck] Initial token fetch failed:', err)
  //   );
  // }

  // private initializeAppCheck() {
  //   try {
  //     console.log('[AppCheck] Initializing AppCheck with ReCaptcha provider');
  //     this.appCheck = initializeAppCheck(this.app, {
  //       provider: new ReCaptchaEnterpriseProvider(this.reCaptchaSiteKey),
  //       isTokenAutoRefreshEnabled: false,
  //     });
  //   } catch (error) {
  //     console.error('[AppCheck] Failed to initialize:', error);
  //   }
  // }

  // private setupNetworkListeners(): void {
  //   this.handleOnline = () => {
  //     this.ngZone.run(async () => {
  //       console.info('[AppCheck] Network online. Checking if token refresh needed.');
  //       if (sessionStorage.getItem('needsAppCheckToken') === 'true') {
  //         await this.getToken(true);
  //       }
  //     });
  //   };

  //   this.handleOffline = () => {
  //     console.error('[AppCheck] Network offline. Token fetch paused.');
  //   };

  //   window.addEventListener('online', this.handleOnline);
  //   window.addEventListener('offline', this.handleOffline);
  // }

  // private setupTokenRefresh(): void {
  //   if (this.tokenRefreshTimeout !== null) {
  //     clearTimeout(this.tokenRefreshTimeout);
  //     this.tokenRefreshTimeout = null;
  //   }

  //   const scheduleRefresh = () => {
  //     this.tokenRefreshTimeout = setTimeout(async () => {
  //       this.ngZone.run(async () => {
  //         console.info('[AppCheck] Refreshing token...');
  //         try {
  //           await this.getToken(true);
  //         } catch (err) {
  //           console.error('[AppCheck] Token refresh failed:', err);
  //         }
  //         scheduleRefresh();
  //       });
  //     }, this.tokenRefreshIntervalMs);
  //   };

  //   console.log(`[AppCheck] Scheduling token refresh every ${this.tokenRefreshIntervalMs / 1000 / 60} minutes`);
  //   scheduleRefresh();
  // }

  // private isTokenExpired(): boolean {
  //   if (!this.lastTokenTimestamp) return true;
  //   return Date.now() - this.lastTokenTimestamp >= this.tokenValidityDurationMs;
  // }

  // async getToken(forceRefresh: boolean = false, retries = this.maxRetries, delay = 2000): Promise<AppCheckTokenResult | undefined> {
  //   if (!navigator.onLine) {
  //     console.error('[AppCheck] Offline. Skipping token fetch.');
  //     sessionStorage.setItem('needsAppCheckToken', 'true');
  //     this.appCheckStatusService.setTokenStatus(false);
  //     return undefined;
  //   }

  //   if (this.usingFallbackMode) {
  //     console.log('[AppCheck] Using fallback mode.');
  //     const mockToken: AppCheckTokenResult = {
  //       token: 'fallback-token-for-app-check'
  //     };
  //     this.lastTokenTimestamp = Date.now();
  //     this.appCheckStatusService.setTokenStatus(true);
  //     return mockToken;
  //   }

  //   for (let i = 0; i < retries; i++) {
  //     try {
  //       console.debug(`[AppCheck] Attempt ${i + 1}/${retries} to fetch token`);
  //       const timeoutPromise = new Promise<never>((_, reject) =>
  //         setTimeout(() => reject(new Error('recaptcha-timeout')), 20000)
  //       );

  //       const appCheckTokenResponse = await Promise.race([
  //         getToken(this.appCheck, forceRefresh),
  //         timeoutPromise
  //       ]);

  //       this.lastTokenTimestamp = Date.now();
  //       sessionStorage.removeItem('appCheckErrorShown');
  //       sessionStorage.removeItem('needsAppCheckToken');
  //       this.appCheckStatusService.setTokenStatus(true);
  //       return appCheckTokenResponse;
  //     } catch (error: any) {
  //       const isLastAttempt = i === retries - 1;

  //       if (error?.message === 'recaptcha-timeout') {
  //         console.error(`[AppCheck] Timeout (attempt ${i + 1})`);
  //       } else {
  //         console.error(`[AppCheck] Token fetch error (attempt ${i + 1}):`, error);
  //       }

  //       if (isLastAttempt) {
  //         console.error('[AppCheck] Max retries reached. Reloading AppCheck.');
  //         this.appCheckStatusService.setTokenStatus(false);
  //         await this.reloadAppCheck();
  //       }

  //       if (['appCheck/recaptcha-error', 'appCheck/unavailable'].includes(error.code) || error.message === 'recaptcha-timeout') {
  //         await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
  //       } else {
  //         console.error('[AppCheck] Unhandled error:', error);
  //         this.appCheckStatusService.setTokenStatus(false);
  //         break;
  //       }
  //     }
  //   }

  //   if (!sessionStorage.getItem('appCheckErrorShown')) {
  //     sessionStorage.setItem('appCheckErrorShown', 'true');
  //      sessionStorage.removeItem("visitedSalesInterim");
  //   }

  //   this.appCheckStatusService.setTokenStatus(false);
  //   return undefined;
  // }

  // async reloadAppCheck() {
  //   try {
  //     console.log('[AppCheck] Reloading AppCheck...');
  //     const existingToken = await this.getToken(false);
  //     if (existingToken?.token) return;

  //     await this.getToken(true);
  //   } catch (error: any) {
  //     console.error('[AppCheck] reloadAppCheck error:', error);
  //     if (error?.code === 'appCheck/unavailable') {
  //       setTimeout(() => this.reloadAppCheck(), 5000);
  //     }
  //   }
  // }



  // ngOnDestroy(): void {
  //   if (this.translationSubscription) {
  //     this.translationSubscription.unsubscribe();
  //   }
  //   if (this.tokenRefreshTimeout !== null) {
  //     clearTimeout(this.tokenRefreshTimeout);
  //     this.tokenRefreshTimeout = null;
  //   }
  //   window.removeEventListener('online', this.handleOnline);
  //   window.removeEventListener('offline', this.handleOffline);
  // }

}
